// useCreateQuery Hook
import { useState, useCallback, useMemo } from "react";
import {
  QueryEntity,
  CreateQueryParams,
} from "../../domain/entities/QueryEntity";
import { CreateQueryUseCase } from "../../domain/use-cases/CreateQueryUseCase";
import { QueriesRepositoryImpl } from "../../data/repositories/QueriesRepositoryImpl";
import { queriesApi } from "../../data/api/queriesApi";
import { Result } from "../../domain/common/Result";

export const useCreateQuery = () => {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Instantiate repository and use case
  const repository = useMemo(() => new QueriesRepositoryImpl(queriesApi), []);

  const createQueryUseCase = useMemo(
    () => new CreateQueryUseCase(repository),
    [repository]
  );

  const createQuery = useCallback(
    async (params: CreateQueryParams): Promise<Result<QueryEntity>> => {
      setCreating(true);
      setError(null);

      const result = await createQueryUseCase.execute(params);

      if (result.isFailure) {
        setError(result.error);
      }

      setCreating(false);
      return result;
    },
    [createQueryUseCase]
  );

  return {
    createQuery,
    creating,
    error,
  };
};
